import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";

import TreemapCharts from "../Components/TreemapCharts";

const HeatmapsPage = (props) => {

  const theme = useTheme();
  return (
    <div
      style={{
        paddingLeft: "20px",
        display: "flex",
        flexDirection: "column",
        minHeight: '100vh',
        minWidth: '100vw',
        background: `${theme.palette.background.default}`,
      }}
    >
       <TreemapCharts></TreemapCharts>
    </div>
  );
};

export default HeatmapsPage;
